export const getRoleName = () => localStorage.getItem('roleName');

export const canAccess = () => {
    const roleName = getRoleName();
    const permissionAccessRoles = ['Owner', 'Admin', 'Manager', 'Dashboard User'];
    return permissionAccessRoles.includes(roleName);
}
